import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../../../usecases/object";
import Table from "../../../../../../components/Table";
import BaseListPage from "../../../../../../base/BaseListPage";
import SearchSelect from "../../../../../../components/searchSelect/SearchSelect";
import InputFactory from "../../../../../../components/InputFactory";
import AdditionalTalbePresenter from "../../additional-info/AdditionalTalbePresenter";
import { DialogConfirmation } from "../../../../../../components/common/Converter";

export default class LeaveCredits extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new AdditionalTalbePresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
    this.state = {
      objects: [],
      leaveTypes: [],
      selectLeave: "",
      object: [],
      initialData: [],
      leaveCredits: "",
      objectID: "",
      count: 0,
      limit: 10,
      current: 1,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.objects !== this.state.objects) {
      const initialEmails = new Set(
        this.state.initialData.map((data) => data.type)
      );
      const newObjects = this.state.objects.filter(
        (data) => !initialEmails.has(data.type)
      );
      if (newObjects.length > 0) {
        localStorage.setItem("LeaveCredit", JSON.stringify(newObjects));
      }
    }
  }

  getCurrent() {
    return this.props.object.id;
  }

  async componentDidMount() {
    this.presenter.componentDidMount();
    const leave = await findObjectUseCase().execute("leave_type");
    const selectLeave = localStorage.getItem("selectLeave");
    const email = this.props.object.id;
    const newObject = await findObjectUseCase().execute("leave_cred", {
      where: { empID: email },
    });
    this.setState({
      initialData: newObject,
      leaveTypes: leave,
      selectLeave,
    });
  }

  getCollectionName() {
    return "leave_cred";
  }

  // delete function
  async handleDeleteData(object) {
    DialogConfirmation(
      object.id,
      "leave_cred",
      async () => {
        if (["Sick Leave", "Vacation Leave"].includes(object.type)) {
          const earned = `-${object.current}`;
          const balance = "0";
          const date = new Date();
          const leaveCard = {
            employee: { id: this.props.object.id },
            leaveType: object?.type,
            earned,
            balance,
            startDate: date,
            endDate: date,
            status: "Leave Credits",
          };
          await upsertUseCase().execute("leave_card", leaveCard);
        }

        this.refetchData(); // proceed with refresh after deletion
      },
      true
    );
  }

  handleObjectData(data) {
    sessionStorage.setItem("selectLeave", data.type);
    this.setState({ selectLeave: data.type, leaveCredits: data.current });
    this.setState({ objectID: data.id });
  }

  async handleLeaveCreditChange(selectLeave) {
    this.setState({ objectID: "" });
    this.setState({ selectLeave });
    sessionStorage.setItem("selectLeave", selectLeave);
  }
  onChangeLeaveCredits(leaveCredits) {
    this.setState({ leaveCredits });
  }

  async handleSaveOnClick() {
    const { object } = this.props;
    const unique = await findObjectUseCase().execute("leave_cred", {
      where: { empID: object.id, type: this.state.selectLeave },
    });

    const data = {
      email: object.email,
      empID: object.id,
      type: this.state.selectLeave,
      current: this.state.leaveCredits.toString(),
    };

    // Generate Leave Card
    if (["Sick Leave", "Vacation Leave"].includes(data.type)) {
      this.upsertLeaveCard(data, object, unique);
    }

    if (this.state.objectID !== "") {
      data.id = this.state.objectID;
      await upsertUseCase().execute("leave_cred", data);
      await this.refetchData();
      await this.refetchData();
    } else {
      if (unique.length > 0) {
        this.showError("You cannot add same leave type.");
        return;
      } else {
        // console.warn("DATA: ", data);
        this.setState({ selectLeave: "", leaveCredits: "" });
        await upsertUseCase().execute("leave_cred", data);
        await this.refetchData();
        await this.refetchData();
      }
    }
  }

  async upsertLeaveCard(data, object, unique) {
    const earned =
      parseFloat(data?.current) - (parseFloat(unique[0]?.current) || 0);
    const balance = data.current;
    const date = new Date();
    const leaveCard = {
      employee: { id: object.id },
      leaveType: data.type,
      earned: earned.toFixed(3),
      balance,
      startDate: date,
      endDate: date,
      status: "Leave Credits",
    };
    await upsertUseCase().execute("leave_card", leaveCard);
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }
  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { leaveTypes, objects, loading, current, limit, count } = this.state;

    return (
      <>
        <div className="m-4">
          <div className="row">
            <div className="col-lg-3 p-1 mb-4">
              <SearchSelect
                value={this.state.selectLeave}
                onChange={this.handleLeaveCreditChange.bind(this)}
                onClickClear={() => this.handleLeaveCreditChange("")}
                options={leaveTypes.map((leave) => ({
                  label: leave.name,
                  value: leave.name,
                }))}
              />
            </div>
            <div className="col-lg-3 p-1 mb-4">
              <InputFactory
                type="String"
                _type="DecemalNum"
                field="leaveCredits"
                value={this.state.leaveCredits}
                uppercase
                onChange={this.onChangeLeaveCredits.bind(this)}
              />
            </div>

            <div className="col-lg-3 p-1">
              <button
                type="button"
                onClick={this.handleSaveOnClick.bind(this)}
                className="btn btn-primary fs-sm me-3"
              >
                Save
              </button>
            </div>
          </div>

          <Table
            // objectId={this.handleDeleteData.bind(this)}
            ofAppearance={this.handleDeleteData.bind(this)}
            refetch={this.refetchData.bind(this)}
            objectData={this.handleObjectData.bind(this)}
            progress={loading}
            fields={schema.fields}
            objects={objects}
            collection={schema}
            count={count}
            limit={limit}
            current={current}
            loadPagination={this.onClickPagination.bind(this)}
            actionsList={[
              {
                label: <i className="bi bi-pencil-square" />,
                actionType: "object",
              },
              {
                label: <i className="bi bi-trash" />,
                actionType: "ofAppearance",
              },
            ]}
            excludeFields={Object.keys(schema.fields).reduce(
              (acc, key) => {
                const options = schema.fields[key];
                if (options.read === false) {
                  acc.push(key);
                }
                switch (options._type || options.type) {
                  case "Relation":
                  case "Array":
                  case "Object":
                  case "File":
                    acc.push(key);
                    break;
                  default:
                }
                return acc;
              },
              ["id", "Created At", "Updated At", "name", "email"]
            )}
            onClickItem={this.onClickItem.bind(this)}
          />
        </div>
      </>
    );
  }
}
